export var Types;
(function (Types) {
    Types["UPDATE_MESSAGES"] = "UPDATE_MESSAGES";
    Types["NEW_MESSAGE"] = "NEW_MESSAGE";
    Types["UDPATE_HAS_NEW"] = "UDPATE_HAS_NEW";
    Types["UPDATE_FETCH_MORE_METHOD"] = "UPDATE_FETCH_MORE_METHOD";
    Types["UPDATE_FETCH_MORE_MESSAGES"] = "UPDATE_FETCH_MORE_MESSAGES";
    Types["UPDATE_MARK_READ_METHOD"] = "UPDATE_MARK_READ_METHOD";
    Types["UPDATE_HAS_MORE"] = "UPDATE_HAS_MORE";
    Types["RESET_HAS_CUSTOMER_ADDED_NEW_MESSAGE"] = "RESET_HAS_CUSTOMER_ADDED_NEW_MESSAGE";
})(Types || (Types = {}));
//# sourceMappingURL=MessageActions.js.map